module.exports = __webpack_public_path__ + "pstatic/img/report2.f3431497.png";